import { useLocation, useNavigate } from 'react-router';
import Container from '../components/common/Container';
import PageHeader from '../components/common/PageHeader';
import PanelUsersTable from '../components/PanelUsers/Table';
import PlusIcon from '../components/common/Icons/PlusIcon';

const PanelUsers = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Container>
      <PageHeader
        pageTitle="Panel Kullanıcıları"
        isButtoned
        buttonIcon={<PlusIcon />}
        buttonText="Yeni Kullanıcı"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <PanelUsersTable />
    </Container>
  );
};

export default PanelUsers;
